import { Link, useNavigate } from 'react-router-dom'
import { Phone, UtensilsCrossed } from 'lucide-react'
import { ChevronLeftIcon } from '@heroicons/react/24/outline'
import { DotLottieReact } from '@lottiefiles/dotlottie-react'
import { useLanguage } from '../contexts/LanguageContext'
import { useRestaurant } from '../contexts/RestaurantContext'

const SUCCESS_LOTTIE_URL = 'https://lottie.host/16bd8326-3901-4ded-a8fd-07f2366892ba/AyxGeGKDpI.lottie'

export default function ReservationSuccess() {
  const navigate = useNavigate()
  const { t } = useLanguage()
  const { restaurantInfo } = useRestaurant()

  return (
    <div className="min-h-screen bg-[#fafafa] flex flex-col pb-24">
      <header className="sticky top-0 z-30 bg-[#fafafa] shrink-0">
        <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-between">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="p-2 -m-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
            aria-label={t('back')}
          >
            <ChevronLeftIcon className="w-5 h-5 rtl:scale-x-[-1]" />
          </button>
          <h1 className="text-base font-bold text-gray-800">{t('reservation')}</h1>
          <div className="w-9" aria-hidden />
        </div>
      </header>

      <div className="flex-1 max-w-md mx-auto w-full px-4 pt-12 pb-8 text-center">
        <div className="mb-6">
          <div className="w-24 h-24 mx-auto mb-4 flex items-center justify-center">
            <DotLottieReact
              src={SUCCESS_LOTTIE_URL}
              loop={false}
              autoplay
              style={{ width: '96px', height: '96px' }}
            />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">{t('reservationSuccess')}</h2>
          <p className="text-gray-600">
            {t('reservationSuccessMessage')}
          </p>
        </div>

        <p className="text-sm text-gray-600 mb-6">
          {t('reservationSuccessHint')}
        </p>

        {restaurantInfo?.phone_number && (
          <div className="mb-6">
            <p className="text-sm text-gray-600 mb-2">Need help?</p>
            <a
              href={`tel:${restaurantInfo.phone_number}`}
              className="inline-flex items-center gap-2 text-amber-500 hover:text-amber-600"
            >
              <Phone className="w-4 h-4" />
              {restaurantInfo.phone_number}
            </a>
          </div>
        )}

        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 w-full max-w-xs mx-auto bg-orange-500 text-white py-3.5 rounded-xl font-bold text-sm uppercase hover:bg-orange-600 transition-colors"
        >
          <UtensilsCrossed className="w-5 h-5" />
          {t('browseMenu')}
        </Link>
      </div>
    </div>
  )
}
